<template>
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.29293 5.00001L0.646484 8.64645L1.35359 9.35356L5.00004 5.70711L8.64648 9.35356L9.35359 8.64645L5.70715 5.00001L9.35359 1.35356L8.64648 0.646454L5.00004 4.2929L1.35359 0.646454L0.646484 1.35356L4.29293 5.00001Z"
      fill="#878787" />
  </svg>
</template>

<script>
export default {
  name: "Deselect",
};
</script>
